import {Component} from '@angular/core';

@Component({
    template: '<div>ErrorComponent</div>',
    standalone: false
})
export class ErrorComponent {

}
